module.exports = __webpack_public_path__ + "img/Mount_Hood.7e8a474c.jpg";